export default (state) => {
    return state.ui.section || false; 
};
